import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { useMediaQuery } from 'react-responsive'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			buttonContainerStyle: {
				position: 'fixed',
				width: 420,
				height: 50,
				bottom: 50,
				right: 40
			},
			buttonStyle: {
				width: '100%',
				background: theme.palette.blue['5'],
				padding: '15px 22px',
				maxWidth: 200,
				borderRadius: 24.5,
				boxSizing: 'border-box'
			},
			justifySpace: {
				justifyContent: 'space-between'
			},
			doubleButtonMobile: {
				maxWidth: '160px !important'
			}
		}
	)
)

interface AcceptingProps {
	onFooterPreviousClicked: () => void
	onFooterNextClicked?: () => void
	step?: number
}

type FooterProps = AcceptingProps

const Footer: React.FC<FooterProps> = (
	{
		onFooterPreviousClicked,
		onFooterNextClicked,
		step = 1
	}
) => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const buttonContainerClass: ClassValue = classNames(
		classes.flex,
		classes.flexEnd,
		{
			[classes.buttonContainerStyle]: isLargeScreen,
			[classes.justifySpace]: step % 1
		}
	)

	const buttonClass: ClassValue = classNames(
		classes.flex,
		classes.flexEnd,
		classes.alignCenter,
		classes.buttonStyle,
		classes.cursorPointer,
		{
			[classes.doubleButtonMobile] : step % 1 && !isLargeScreen
		}
	)

	return (
		<div className={buttonContainerClass}>
			<div
				className={buttonClass}
				onClick={onFooterPreviousClicked}
			>
				<ArrowBackIosIcon />

				<span className={classes.text8}>
						<FormattedMessage
							id="requests.makeRequest.previousStep"
							defaultMessage="Previous step"
							description="Previous step text"
						/>
					</span>
			</div>
			{(step % 1) ?
				<div
					className={buttonClass}
					onClick={onFooterNextClicked}
				>

					<span className={classes.text8}>
						<FormattedMessage
							id="requests.makeRequest.nextStep"
							defaultMessage="Next step"
							description="Next step text"
						/>
					</span>
					<ArrowForwardIosIcon />
				</div>
				:
				<></>
			}
		</div>
	)
}

export default Footer
